import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { encryptAES } from "../../Common/Axios/encrypt";
import getTranslation from "../../TranslationUtility/TranslationUtility";
import feature from "../../Assets/imgNewUI/featured.svg";
import arrowRightImg from "../../Assets/img/arrow-right.svg";
import ArrowForwardIcon from "../../Assets/imgNewUI/arrow_forward_Home.svg";
import { DealCouponFreqData, FormatDate } from "../../Utility/Utility";

const CommonOffer = ({
    deal,
    matchingCoupon,
    isFeature,
    handleDealCoupon,
    bgImg,
    index,
    couponCount,
    isMobileView,
}) => {
    const navigate = useNavigate();
    const translation = getTranslation();
    const clientMasterData = useSelector((state) => state.clientMasterReducer);
    const clientData = clientMasterData?.clientMasterData || [];
    const clientCode = clientData?.[0]?.clientCode;
    const { dealCoupounFrequencies } = useSelector((state) => state?.dealsDataSlice?.allofferData);
    const { dealCouponFreqData } = DealCouponFreqData();
    const dealCoupounFrequenciesList = [...dealCouponFreqData, ...dealCoupounFrequencies || []];
    const expiryDate = dealCoupounFrequenciesList?.find(
        (code) => code?.dealCoupounId === matchingCoupon[0]?.id
    )?.validUpto;

    const handleClaim = (dealData) => {
        if (!isMobileView) {
            navigate(`/Offers?did=${encryptAES(String(dealData?.id))}`);
        }
        if (typeof handleDealCoupon === "function") {
            handleDealCoupon(dealData);
        }
    };

    console.log({ deal, matchingCoupon });

    let cardTypes = Array.isArray(matchingCoupon) ? matchingCoupon?.filter(c => c?.cardType)?.reduce((acc, c) => {
        if (!acc.includes(c?.cardType) && c?.cardType) {
            if (acc.length > 0) {
                acc += " & ";
            }
            acc += c?.cardType;
        }
        return acc;
    }, "")?.trim() : "";
    cardTypes = cardTypes.replaceAll(",", " & ")?.replaceAll((translation?.DebitCardLabel).trim(), "Debit");

    const badgePriority = [
        translation?.badgeFeatured,
        translation?.badgeExpiringSoon,
        translation?.badgeNew,
    ];

    const badgeColors = {
        [translation?.badgeFeatured]: { bg: "var(--offer-badge-featured-bg, #8B4EC7)", text: "var(--offer-badge-featured-text, #FFFFFF)" },
        [translation?.badgeExpiringSoon]: { bg: "var(--offer-badge-expiring-bg, #9C4424)", text: "var(--offer-badge-expiring-text, #FFFFFF)" },
        [translation?.badgeNew]: { bg: "var(--offer-badge-new-bg, #0F8068)", text: "var(--offer-badge-new-text, #FFFFFF)" },
    };

    const offerBadge = badgePriority?.find(priority =>
        matchingCoupon?.some(c => c?.offerBadge === priority)
    );
    return (
        <div key={index} className="w-25 relative new-offer-img-width">
            {/* New Card Design */}
            <div className="new-offer-card" onClick={() => handleClaim(deal)}>
                {offerBadge && <div className="offer-card-badge" style={{ backgroundColor: badgeColors[offerBadge]?.bg }}>
                    <span className="badge-text" style={{ color: badgeColors[offerBadge]?.text }}>{offerBadge}</span>
                </div>}

                {/* Card Header */}
                <div className="offer-card-header">
                    <div className="offer-card-brand">
                        <img
                            src={isMobileView
                                ? deal?.mobImage
                                    ? `${process.env.REACT_APP_CLIENT_IMAGE_URL}${deal.mobImage}`
                                    : `${process.env.REACT_APP_CLIENT_IMAGE_URL}${clientCode}/img/Placeholder.svg`
                                : deal?.webImage
                                    ? `${process.env.REACT_APP_CLIENT_IMAGE_URL}${deal.webImage}`
                                    : `${process.env.REACT_APP_CLIENT_IMAGE_URL}${clientCode}/img/Placeholder.svg`}
                            alt={matchingCoupon[0]?.title}
                            className="brand-logo"
                            onError={(e) => (e.target.src = `${process.env.REACT_APP_CLIENT_IMAGE_URL}${clientCode}/img/Placeholder.svg`)}
                        />
                    </div>
                </div>

                {/* Card Body */}
                <div className="offer-card-body">
                    <div>
                        <h3 className="offer-card-title">{deal?.name}</h3>
                        <div className="offer-card-amount">
                            {matchingCoupon[0]?.title}
                        </div>
                    </div>

                    <div className="offer-card-info">
                        <span className={cardTypes ? "info-label" : "info-label-empty"}>{cardTypes || "\u00A0"}</span>
                    </div>

                    <div className="offer-card-expiry">
                        <div className="expiry-info">
                            <span className="expiry-label">{translation?.expiresOn}</span>
                            <span className="expiry-date">{FormatDate(expiryDate)}</span>
                        </div>
                        <div className="offer-card-arrow">
                            <img src={ArrowForwardIcon} alt=">" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CommonOffer;
